import React from 'react';
import { HeroSection } from './components/HeroSection';
import { CredibilitySection } from './components/CredibilitySection';
import { DiagnosticoSection } from './components/DiagnosticoSection';
import { CuraSection } from './components/CuraSection';
import { ContactForm } from './components/ContactForm';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <main className="min-h-screen bg-dark text-white font-sans selection:bg-emerald selection:text-dark" data-id="element-0">
      {/* Global Noise Overlay for premium texture */}
      <div className="fixed inset-0 z-50 pointer-events-none opacity-[0.03] mix-blend-overlay" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`
    }} data-id="element-1" />

      <HeroSection data-id="element-2" />
      <CredibilitySection data-id="element-3" />
      <DiagnosticoSection data-id="element-4" />
      <CuraSection data-id="element-5" />
      <FinalCTA data-id="element-6" />
      <ContactForm data-id="element-7" />
      <Footer data-id="element-8" />
    </main>;
}